const state = () => ({
  quizzes: [],
  isLoading: false,
});

const mutations = {
  setQuizzes(currentState, payload) {
    currentState.quizzes = payload;
  },
  setIsLoading(currentState, payload) {
    currentState.isLoading = payload;
  },
};
// actions
const actions = {
  async init({ state: currentState, commit }) {
    if (currentState.quizzes.length) return;
    if (currentState.isLoading) return;
    commit('setIsLoading', true);
    try {
      const { href } = window.location;
      const { data } = await this.$api.get(
        this.getters.getApiLink('quiz.settings') + `?url=${encodeURIComponent(href)}`,
      );
      commit('setQuizzes', data);
      commit('setIsLoading', false);
    } catch (e) {
      commit('setIsLoading', false);
      throw new Error(e);
    }
  },
};

const getters = {
  quizzes: (currentState) => currentState.quizzes,
  activeQuiz: (currentState, currentGetters) => {
    return (
      currentGetters.quizzes.find((e) => e.isEnabled && e.openOnLoad) ||
      currentGetters.quizzes.find((e) => e.isEnabled) ||
      {}
    );
  },
  onboardingQuiz: (currentState) =>
    currentState.quizzes.find((quiz) => quiz.type === 'onboarding') || {},
  usaQuiz: (currentState) =>
    currentState.quizzes.find((quiz) => quiz.type === 'userAssessment') || {},
  registrationQuiz: (currentState) =>
    currentState.quizzes.find((quiz) => quiz.type === 'registration') || null,
  isLoading: (currentState) => currentState.isLoading,
  jobratingQuiz: (currentState) =>
    currentState.quizzes.find((quiz) => quiz.type === 'jobrating' && quiz.isEnabled) || null,
};

export default {
  namespaced: true,
  mutations,
  state,
  actions,
  getters,
};
